"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _Tooltip = _interopRequireDefault(require("./Tooltip"));
const ErrorFormTooltip = ({
  shown,
  onShown,
  error,
  help,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, shown && help && !error && /*#__PURE__*/React.createElement(_Tooltip.default, (0, _extends2.default)({
    isHelp: true,
    shown: shown,
    onShown: () => onShown(prev => !prev)
  }, props), help), shown && error && /*#__PURE__*/React.createElement(_Tooltip.default, (0, _extends2.default)({
    shown: shown,
    onShown: value => onShown(value)
  }, props), error));
};
var _default = exports.default = ErrorFormTooltip;